import * as React from 'react';
export const SuperModeratePortfolio = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 79 76" fill="none" {...props}>
    <path
      d="M1.953 50.63l30.455 2.38a16.742 16.742 0 014.766-10.043L15.236 21.701C7.55 29.555 2.9 39.834 1.953 50.63zM44.295 7.732l2.974 30.41a16.724 16.724 0 0110.767 2.569l17.11-25.3C66.133 9.433 55.214 6.649 44.303 7.74l-.008-.008z"
      stroke="#600CE8"
      strokeWidth={2.776}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.893 42.298l-4.003-17.98c-.053-.473.526-.74.854-.396L45.84 38.349c.526-.1 1.052-.183 1.578-.237L44.33 7.718a47.127 47.127 0 00-15.815 4.46c-5.124 2.471-9.516 5.682-13.244 9.494L37.29 42.855c.19-.19.404-.374.61-.557h-.008z"
      fill="#600CE8"
      stroke="#600CE8"
      strokeWidth={2.776}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.862 66.869c6.974 0 12.627-5.654 12.627-12.627 0-6.974-5.653-12.628-12.627-12.628-6.974 0-12.628 5.654-12.628 12.628s5.654 12.627 12.628 12.627zM16.809 3.515l-.892.45s-.374.19-.618.518c-.26.336-.42.862-.42.87L14.4 7l-.488-1.647c-.038-.153-.205-.595-.419-.87-.236-.312-.61-.503-.618-.518l-.9-.45.9-.458s.374-.19.618-.503c.26-.343.42-.861.42-.869l.48-1.647.488 1.647c.045.152.206.595.42.87.243.312.617.502.617.502l.892.458zM78.04 55.976l-1.534.763s-.625.328-1.044.884c-.45.565-.717 1.472-.717 1.487l-.824 2.806-.838-2.806c-.076-.252-.343-1.006-.717-1.487-.404-.541-1.03-.87-1.045-.884l-1.548-.763 1.548-.778s.626-.328 1.045-.869c.45-.58.717-1.471.717-1.487l.83-2.806.84 2.806c.076.252.343 1.007.716 1.487.42.541 1.045.87 1.045.87l1.533.777h-.008zM30.692 70.684l-1.12.557s-.466.244-.77.648c-.329.412-.535 1.083-.535 1.09l-.61 2.059-.617-2.059c-.061-.183-.252-.732-.534-1.09-.297-.397-.762-.64-.77-.648l-1.129-.557 1.129-.572s.465-.244.77-.64c.328-.427.534-1.083.534-1.09l.61-2.06.617 2.06c.061.182.252.731.534 1.09.305.396.77.64.77.64l1.121.572z"
      fill="#600CE8"
    />
  </svg>
);
